export enum SubProjectStatusEnum {
  New = 'New',
  WaitingForPriceConfirm = 'WaitingForPriceConfirm',
  PriceConfirmed = 'PriceConfirmed',
  PriceNotConfirmed = 'PriceNotConfirmed',
  Frozen = 'Frozen',
  Old = 'Old'
}
